/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ApolloError } from '@apollo/client';

export type FormattedApolloError = {
  message?: string;
  errorMessage: string;
  code?: string;
  requestId?: string;
};

/**
 * Formats a client-side Apollo Error into a FormattedApolloError.
 */
export const formatApolloError = (error: ApolloError): FormattedApolloError => {
  const { graphQLErrors } = error;

  const errors = [];
  if (graphQLErrors && graphQLErrors.length > 0) {
    errors.push(...graphQLErrors);
  }

  if (errors.length > 0) {
    const { message: errorMessage, extensions } = errors[0];
    const requestId = extensions?.requestId as string;
    const code = extensions?.code as string;
    const message = extensions?.message as string;

    return {
      errorMessage,
      code,
      requestId,
      message,
    };
  }

  return {
    errorMessage: error.message,
    code: error.extraInfo?.code,
    requestId: error.extraInfo?.requestId,
    message: error.extraInfo?.message,
  };
};
